var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPartnership = function SvgPartnership(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 480 347"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#partnership_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 163,
    fill: "#51C394",
    rx: 42.895,
    transform: "matrix(-1 0 0 1 321 89)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#partnership_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#FCB701",
    rx: 15.429,
    transform: "matrix(-1 0 0 1 188 213)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#partnership_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "#3B7CC9",
    rx: 18,
    transform: "matrix(-1 0 0 1 361 54)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M236.51 170.939c-5.442 5.442-14.296 5.442-19.738 0-2.881-2.881-2.881-7.569 0-10.45l14.405-14.404q.569-.568 1.172-1.085h-31.886a2.463 2.463 0 0 0-2.463 2.463v29.956a2.463 2.463 0 0 0 2.463 2.463h12.563l19.463 19.462c3.133 3.134 7.745 3.907 11.61 2.322l-9.288-9.288a2.462 2.462 0 1 1 3.483-3.483l9.869 9.869 4.644-4.644-9.869-9.87a2.462 2.462 0 1 1 3.483-3.483l9.87 9.869 4.644-4.644-19.739-19.739z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M279.61 145h-33.918a15.5 15.5 0 0 0-11.031 4.569l-14.404 14.404a2.46 2.46 0 0 0 0 3.483 9.03 9.03 0 0 0 12.771 0l6.642-6.64c.796-.796 2.039-.964 2.999-.375 2.965 1.819 7.12 1.865 9.559-.573a2.462 2.462 0 1 1 3.483 3.483c-1.912 1.912-4.463 3.016-7.174 3.275l15.883 15.883 2.627-2.627h12.563a2.463 2.463 0 0 0 2.463-2.463v-29.956A2.463 2.463 0 0 0 279.61 145"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M319.673 89.659c0-1.652.578-3.171 1.54-4.369a6.6 6.6 0 0 1-3.78-1.185 6.6 6.6 0 0 1-3.781 1.185.693.693 0 0 1 0-1.388c.984 0 1.904-.272 2.692-.743a6.62 6.62 0 0 1-1.735-3.816h-.956a.693.693 0 1 1 0-1.388h3.086V76.27a.694.694 0 1 1 1.388 0v1.685h3.087a.694.694 0 0 1 0 1.388h-.957a6.6 6.6 0 0 1-1.735 3.816 5.2 5.2 0 0 0 2.692.743c.366 0 .665.284.691.644a6.96 6.96 0 0 1 4.754-1.873h3.207v-2.925l4.098-2.926a1.23 1.23 0 0 0 0-2.003l-4.147-2.962A4.53 4.53 0 0 0 325.341 68h-15.816A4.53 4.53 0 0 0 305 72.525v15.816a4.53 4.53 0 0 0 4.525 4.525h10.148zm6.985-4.526h15.815a4.53 4.53 0 0 1 4.526 4.526v15.815a4.53 4.53 0 0 1-4.526 4.526h-15.815a4.53 4.53 0 0 1-4.476-3.857l-4.147-2.963a1.229 1.229 0 0 1 0-2.002l4.098-2.927v-8.593a4.53 4.53 0 0 1 4.525-4.525m9.918 16.948c.065.25.289.342.579.342.462 0 1.081-.303 1.081-.711a.4.4 0 0 0-.018-.1l-.008-.032-2.544-8.29c-.118-.396-.606-.58-1.107-.58-.488 0-.975.184-1.094.58l-2.544 8.29v.002c-.013.052-.026.104-.026.13 0 .422.619.711 1.081.711.29 0 .514-.092.58-.342l.5-1.753h3.019zm-.868-3.097h-2.294l1.147-4.046zm-16.849-19.64a5.24 5.24 0 0 1-1.426 2.948 5.25 5.25 0 0 1-1.425-2.949z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M169.332 228.429h-22.207a.67.67 0 0 0-.672.672v29.513c0 .371.301.672.672.672h6.511a.67.67 0 0 0 .672-.672v-5.348h7.841v5.348c0 .371.301.672.672.672h6.51a.67.67 0 0 0 .672-.672v-29.513a.67.67 0 0 0-.671-.672m-15.444 19.825a.504.504 0 0 1-.504.504h-2.997a.504.504 0 0 1-.504-.504v-2.997c0-.278.226-.504.504-.504h2.997c.278 0 .504.226.504.504zm0-6.343a.504.504 0 0 1-.504.504h-2.997a.504.504 0 0 1-.504-.504v-2.996c0-.279.226-.504.504-.504h2.997c.278 0 .504.225.504.504zm0-6.343a.504.504 0 0 1-.504.504h-2.997a.504.504 0 0 1-.504-.504v-2.996c0-.279.226-.504.504-.504h2.997c.278 0 .504.225.504.504zm6.342 12.686a.504.504 0 0 1-.504.504h-2.996a.504.504 0 0 1-.504-.504v-2.997c0-.278.225-.504.504-.504h2.996c.279 0 .504.226.504.504zm0-6.343a.503.503 0 0 1-.504.504h-2.996a.503.503 0 0 1-.504-.504v-2.996c0-.279.225-.504.504-.504h2.996c.279 0 .504.225.504.504zm0-6.343a.503.503 0 0 1-.504.504h-2.996a.503.503 0 0 1-.504-.504v-2.996c0-.279.225-.504.504-.504h2.996c.279 0 .504.225.504.504zm6.343 12.686a.504.504 0 0 1-.504.504h-2.996a.504.504 0 0 1-.504-.504v-2.997c0-.278.225-.504.504-.504h2.996c.279 0 .504.226.504.504zm0-6.343a.503.503 0 0 1-.504.504h-2.996a.503.503 0 0 1-.504-.504v-2.996c0-.279.225-.504.504-.504h2.996c.279 0 .504.225.504.504zm0-6.343a.503.503 0 0 1-.504.504h-2.996a.503.503 0 0 1-.504-.504v-2.996c0-.279.225-.504.504-.504h2.996c.279 0 .504.225.504.504z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3F3FF",
    d: "M154.913 93.583a9.046 9.046 0 0 1-11.067 6.421 9.05 9.05 0 1 1 11.067-6.421M369.814 234.393a9.046 9.046 0 0 1-11.068 6.421 9.049 9.049 0 1 1 4.647-17.49c4.831 1.283 7.704 6.239 6.421 11.069"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "partnership_svg__a",
    width: 283.105,
    height: 283.105,
    x: 101.379,
    y: 42.674,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.432,
    dy: 13.726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.026
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_561_12551"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_561_12551",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "partnership_svg__b",
    width: 180,
    height: 180,
    x: 71.429,
    y: 166.714,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.429,
    dy: 13.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_561_12551"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_561_12551",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "partnership_svg__c",
    width: 210,
    height: 210,
    x: 225,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_561_12551"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_561_12551",
    result: "shape"
  })))));
};
export default SvgPartnership;